// Messages for operator/settings/Maintenance (auto-merged into the i18n catalog).
export const en = {
  'operator.maintenance.head': 'Maintenance — Operator',
  'operator.maintenance.title': 'Maintenance',
  'operator.maintenance.desc': 'Guarded operational tasks. Every run is audited.',
  'operator.maintenance.run': 'Run',
  'operator.maintenance.running': 'Running…',
  'operator.maintenance.ran': '{task} started.',
  'operator.maintenance.tasks.clear_cache.title': 'Clear caches',
  'operator.maintenance.tasks.clear_cache.desc': 'Flush the application cache (Solid Cache).',
  'operator.maintenance.tasks.clear_cache.confirm': 'Flush the entire application cache?',
  'operator.maintenance.tasks.reseed.title': 'Re-run seeds',
  'operator.maintenance.tasks.reseed.desc': 'Reload idempotent seed data (non-production only).',
  'operator.maintenance.tasks.reseed.confirm': 'Re-run the seeds now?',
  'operator.maintenance.tasks.rebuild_derived.title': 'Rebuild derived data',
  'operator.maintenance.tasks.rebuild_derived.desc':
    'Recompute denormalized fields and refresh materialized views (queued).',
  'operator.maintenance.tasks.rebuild_derived.confirm': 'Queue a rebuild of derived data?',
  'operator.maintenance.tasks.purge_expired.title': 'Purge expired tokens',
  'operator.maintenance.tasks.purge_expired.desc':
    'Delete expired invitations, magic links and password resets.',
  'operator.maintenance.tasks.purge_expired.confirm': 'Purge all expired tokens?',
}

export const zhTW = {
  'operator.maintenance.head': '維護 — 操作員',
  'operator.maintenance.title': '維護',
  'operator.maintenance.desc': '受保護的操作任務。每次執行都會被稽核。',
  'operator.maintenance.run': '執行',
  'operator.maintenance.running': '執行中…',
  'operator.maintenance.ran': '{task} 已開始。',
  'operator.maintenance.tasks.clear_cache.title': '清除快取',
  'operator.maintenance.tasks.clear_cache.desc': '清空應用程式快取（Solid Cache）。',
  'operator.maintenance.tasks.clear_cache.confirm': '要清空整個應用程式快取嗎？',
  'operator.maintenance.tasks.reseed.title': '重新執行種子資料',
  'operator.maintenance.tasks.reseed.desc': '重新載入冪等種子資料（僅限非正式環境）。',
  'operator.maintenance.tasks.reseed.confirm': '現在要重新執行種子資料嗎？',
  'operator.maintenance.tasks.rebuild_derived.title': '重建衍生資料',
  'operator.maintenance.tasks.rebuild_derived.desc':
    '重新計算反正規化欄位並刷新具體化檢視（已排入佇列）。',
  'operator.maintenance.tasks.rebuild_derived.confirm': '要排入重建衍生資料的工作嗎？',
  'operator.maintenance.tasks.purge_expired.title': '清除過期權杖',
  'operator.maintenance.tasks.purge_expired.desc': '刪除過期的邀請、魔法連結與密碼重設。',
  'operator.maintenance.tasks.purge_expired.confirm': '要清除所有過期權杖嗎？',
}
